import { createGraphQLClient as createGraphQLClientBase } from "@edreamsodigeo/frontend-api-client-base";
import { GraphQLClient } from "./types";

export const createGraphQLClient = (): GraphQLClient =>
  createGraphQLClientBase();
